// extracted by mini-css-extract-plugin
export default {"register":"Register_register__P-+Ce","actions":"Register_actions__Tuq8T","link":"Register_link__eOli2"};